import axios from "axios";
import { DefectJson, GradeJson, GradeHistoryItem } from "../types/grading";

const baseURL = process.env.REACT_APP_API_BASE_URL || "http://localhost:4000";
const useMock =
  (process.env.REACT_APP_USE_MOCK_API || "").toLowerCase() === "true";

export const API = axios.create({
  baseURL,
});

API.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

type UploadResponse = {
  image_url: string;
  data: any;
  success: boolean;
  message?: string;
};

export const uploadImageToBackend = async (
  file: File,
  id: any,
): Promise<UploadResponse> => {
  const formData = new FormData();
  formData.append("image", file);

  try {
    const response = await API.post<UploadResponse>(
      `/backend/upload/${id}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      },
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw new Error(
        error.response?.data?.message || "Failed to upload image",
      );
    }
    throw error;
  }
};

export const getAllCardHistory = async (id: any) => {
  try {
    const response = await API.get(`/backend/history/${id}`);
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw new Error(
        error.response?.data?.message || "Failed to upload image",
      );
    }
    throw error;
  }
};

export const loginUser = async (credentials: {
  email: string;
  password: string;
}) => {
  try {
    const response = await API.post("/login", credentials);
    return response.data;
  } catch (error) {
    console.error("Login API error:", error);
    throw error;
  }
};

// Register user
export const registerUser = async (userData: {
  email: string;
  username: string;
  password: string;
}) => {
  try {
    const response = await API.post("/register", userData);
    return response.data;
  } catch (error) {
    console.error("Register API error:", error);
    throw error;
  }
};
